/**
 * SuperAdminRoute Component
 * Guards routes that require super admin privileges
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

interface SuperAdminRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * SuperAdminRoute component that checks for super admin role
 */
export function SuperAdminRoute({ children, redirectTo = '/dashboard' }: SuperAdminRouteProps) {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  // Redirect to landing if not authenticated
  if (!isAuthenticated) {
    console.log('[SuperAdminRoute] Not authenticated, redirecting to /');
    return (
      <Navigate
        to="/"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  // Redirect to dashboard if not super admin
  if (user?.role !== 'super_admin') {
    console.log('[SuperAdminRoute] User role:', user?.role, '- not super_admin, redirecting to', redirectTo);
    return (
      <Navigate
        to={redirectTo}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  console.log('[SuperAdminRoute] Access granted for super admin:', user.email);
  // Render protected content
  return <>{children}</>;
}

export default SuperAdminRoute;
